"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalStore = void 0;
var rxjs_1 = require("rxjs");
var LocalStore = /** @class */ (function () {
    function LocalStore() {
        this.subjects = {};
        window.addEventListener("storage", this.handleEvent.bind(this));
    }
    LocalStore.prototype.getValue = function (key) {
        return localStorage.getItem(key);
    };
    LocalStore.prototype.setValue = function (key, val) {
        localStorage.setItem(key, val);
    };
    LocalStore.prototype.clearValue = function (key) {
        localStorage.removeItem(key);
    };
    LocalStore.prototype.subscribe = function (key, cb) {
        var subject = this.subjects[key];
        if (!subject) {
            subject = new rxjs_1.Subject();
            this.subjects[key] = subject;
        }
        return subject.subscribe(cb);
    };
    LocalStore.prototype.handleEvent = function (e) {
        if (!e.key) {
            return;
        }
        var subject = this.subjects[e.key];
        if (subject) {
            subject.next(e.newValue);
        }
    };
    return LocalStore;
}());
exports.LocalStore = LocalStore;
